export const UPDATE_ONBOARDING_OBJECT = 'UPDATE_ONBOARDING_OBJECT';
export const CLEAR_ONBOARDING_OBJECTS = 'CLEAR_ONBOARDING_OBJECTS';

import { registerBrandUser as registerBrandUserAPI, registerBrand as registerBrandAPI } from '../APIClient/brands';
import { startBrandSubscription as startBrandSubscriptionAPI, updateBrandCustomerEmail as updateBrandCustomerEmailAPI } from '../APIClient/stripe';
import { authenticateUserSession } from '../APIClient/auth';

import { REGISTER_USER_SUCCESS } from './UserActions';
export const UPDATE_BRAND_ONBOARDING_APPLICATION = 'UPDATE_BRAND_ONBOARDING_APPLICATION';
export const CLEAR_BRAND_ONBOARDING_APPLICATION = 'CLEAR_BRAND_ONBOARDING_APPLICATION';
export const UPDATE_BRAND_ONBOARDING_BRAND = 'UPDATE_BRAND_ONBOARDING_BRAND';
export const REGISTER_BRAND_SUCCESS = 'REGISTER_BRAND_SUCCESS';
export const REGISTER_BRAND_FAILURE = 'REGISTER_BRAND_FAILURE';
export const START_BRAND_SUBSCRIPTION_SUCCESS = 'START_BRAND_SUBSCRIPTION_SUCCESS';
export const START_BRAND_SUBSCRIPTION_FAILURE = 'START_BRAND_SUBSCRIPTION_FAILURE';

export const updateBrandOnboardingObject = updates => async dispatch => {
  return dispatch({
    type: UPDATE_ONBOARDING_OBJECT,
    updates
  });
};

export const startBrandSubscription = invoiceEmail => async (dispatch, getState) => {
  const brand = getState().user.profile.brand;

  try {
    if (invoiceEmail) await updateBrandCustomerEmailAPI(brand, invoiceEmail);

    await startBrandSubscriptionAPI(brand);
    return dispatch({ type: START_BRAND_SUBSCRIPTION_SUCCESS, success: true });
  } catch (e) {
    return dispatch({ type: START_BRAND_SUBSCRIPTION_FAILURE, success: false, error: e });
  }
};

export const registerBrand = code => async dispatch => {
  try {
    dispatch({ type: CLEAR_ONBOARDING_OBJECTS });

    const registerBrandResponse = await registerBrandAPI(code);
    return dispatch({
      type: REGISTER_BRAND_SUCCESS,
      success: true,
      brand: registerBrandResponse.brand,
      code
    });
  } catch (e) {
    return dispatch({
      type: REGISTER_BRAND_FAILURE,
      success: false,
      error: e,
      code
    });
  }
};

export const SET_BRAND_DOMAINS_TO_SETUP = 'SET_BRAND_DOMAINS_TO_SETUP';
export const setBrandDomainsToSetup = domains => async dispatch => {
  const domainsToSetup = domains.map(domain => ({ ...domain, connectedShopify: false, isVerified: false }));
  return dispatch({ type: SET_BRAND_DOMAINS_TO_SETUP, domains: domainsToSetup });
};

export const UPDATE_BRAND_DOMAIN_TO_SETUP = 'UPDATE_BRAND_DOMAIN_TO_SETUP';
export const updateBrandDomainToSetup = (domain, updates) => async dispatch => {
  return dispatch({ type: UPDATE_BRAND_DOMAIN_TO_SETUP, domain, updates });
};

export const BRAND_ONBOARDING_PANEL_VIEWED = 'BRAND_ONBOARDING_PANEL_VIEWED';
export const markBrandOnboardingPanelViewed = panelName => async dispatch => {
  return dispatch({ type: BRAND_ONBOARDING_PANEL_VIEWED, panelName });
};

/**
 * @param {Object} credentials - The credentials to register the brand user.
 * @param {string} credentials.email
 * @param {string} credentials.username
 * @param {string} credentials.password
 */
export const registerBrandUser = credentials => async (dispatch, getState) => {
  const { onboarding } = getState();
  const registrationCode = onboarding.brand?.registrationCode;
  const Brand_id = onboarding.brand?.id || onboarding.brand?.brand?.id;
  if (!Brand_id) return window.ALERT.error('Cannot register user without a brand.');

  try {
    // Same response as SYNC_CURRENT_USER
    const response = await registerBrandUserAPI({ ...credentials, Brand_id, registrationCode });

    // Login brand after successful registration
    const credentialsData = { username: credentials.email, password: credentials.password };
    await authenticateUserSession(credentialsData);
    return dispatch({ type: REGISTER_USER_SUCCESS, success: true, user: response.user });
  } catch (e) {
    return dispatch({ type: REGISTER_BRAND_FAILURE, success: false, error: e });
  }
};

export const clearOnboardingObjects = () => async dispatch => {
  return dispatch({ type: CLEAR_ONBOARDING_OBJECTS, success: true });
};
